<template>
    <client-page class="wrap--mypage">
        <v-container>
                <div class="mypage-container">
                    <!-- 네비게이션 메뉴 -->
                    <mypage-navigation />
                    <!-- 페이지 콘텐츠 -->
                    <div class="mypage-contents">
                        <div class="tit-wrap tit-wrap--unberline">
                            <h2 class="tit">작품문의내역</h2>
                        </div>

                        <form-view code="private-sale" skin="private-sale" />
                    </div>
                </div>
        </v-container>
    </client-page>
</template>

<script>
import FormView from "@/components/client/form/form-view.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";

export default {
    components: {
        FormView,
        ClientPage,
        MypageNavigation,
    },
};
</script>
